import { orpc } from "@/utils/orpc.client";
import type { FeaturePageRenderModel } from "@garimpa/api/featurePages/types";

export interface ArtistDirectorySearchState {
  q?: string;
  genre?: string;
  style?: string;
  country?: string;
  decade?: number;
  sort?: "relevance" | "prominence" | "name" | "name-desc" | "begin-asc" | "begin-desc";
  page?: number;
}

export interface ArtistDirectoryIdentity {
  family: "genre" | "style";
  subjectKey: string;
}

export function getArtistDirectoryIdentity(
  page: FeaturePageRenderModel,
): ArtistDirectoryIdentity | null {
  if (page.page.family !== "genre" && page.page.family !== "style") return null;
  return {
    family: page.page.family,
    subjectKey: page.page.subjectKey,
  };
}

export function getArtistDirectoryQueryOptions(
  directory: ArtistDirectoryIdentity,
  search: ArtistDirectorySearchState,
) {
  return orpc.featurePages.searchArtistDirectory.queryOptions({
    input: { ...directory, ...search },
  });
}
